// extracted by mini-css-extract-plugin
export default {"content":"GarageDoorSurfaces_content__BFXWj"};